import { render, staticRenderFns } from "./LayoutClassic.vue?vue&type=template&id=1131cdd4&scoped=true"
import script from "./LayoutClassic.vue?vue&type=script&lang=js"
export * from "./LayoutClassic.vue?vue&type=script&lang=js"
import style0 from "./LayoutClassic.vue?vue&type=style&index=0&id=1131cdd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1131cdd4",
  null
  
)

export default component.exports